import '../css/TeamSidebar.less';

import React from 'react';
import {Link} from 'react-router-dom';
import {Header, Image} from 'semantic-ui-react';
import {Mutation} from 'react-apollo';
import {TeamPageData} from '../pages/TeamPage';
import EditableImage from './EditableImage';
import * as urls from '../util/urls';
import LegacyWBIcon from './elements/LegacyWBIcon';
import {TEAM_PHOTO_UPDATE} from '../graphql/admin';
import {
  UpdateEntityPhotoMutationFn,
  UserAccountType,
} from '../generated/graphql';
import makeComp from '../util/profiler';

interface TeamSidebarProps {
  data: TeamPageData;
}

const TeamSidebar: React.FC<TeamSidebarProps> = makeComp(
  ({data}) => {
    return (
      <div className="sidebar team-sidebar">
        <div className="content">
          <Mutation mutation={TEAM_PHOTO_UPDATE}>
            {(teamUp: UpdateEntityPhotoMutationFn) => (
              <EditableImage
                photoUrl={data.photoUrl}
                displaySize={200}
                label={false}
                readOnly={data.readOnly}
                entityName={data.name}
                save={newVal => {
                  teamUp({
                    variables: {
                      photoUrl: newVal,
                      entityName: data.name,
                    },
                  });
                }}
              />
            )}
          </Mutation>
          <div>
            <Header as="h1">{data.name}</Header>
            {data.userStats.edges.length > 0 && (
              <>
                <div className="user-list-header-wrapper">
                  <span className="user-list-header">Weekly most active</span>
                  <span className="user-run-count-header">Runs</span>
                </div>
                {data.userStats.edges.map(eu => {
                  return (
                    <div key={eu.node.user.id} className="user-listitem">
                      <Image
                        src={eu.node.user.photoUrl}
                        avatar
                        onError={(i: any) => (i.target.style.display = 'none')}
                      />
                      {eu.node.user.accountType === UserAccountType.User ? (
                        <Link to={urls.profilePage(eu.node.user.username)}>
                          {eu.node.user.username}
                        </Link>
                      ) : (
                        eu.node.user.username
                      )}
                      <span className="user-run-count">{eu.node.runCount}</span>
                    </div>
                  );
                })}
              </>
            )}
            <Link
              data-test="team-see-all"
              to={urls.teamMembers(data.name)}
              className="see-all-link">
              <LegacyWBIcon name="configuration" size="large" />
              Team settings ➞
            </Link>
          </div>
        </div>
      </div>
    );
  },
  {id: 'TeamSidebar', memo: true}
);

export default TeamSidebar;
